import React, { useRef } from 'react';
import type { ViewProps } from 'react-native';
import { View, StyleSheet } from 'react-native';
import { Image } from '../../Image';
import {
  IllusBlueberryLarge,
  IllusBlueberryMedium,
  IllusBlueberrySmall,
  IllusGrapefruitLarge,
  IllusGrapefruitMedium,
  IllusGrapefruitSmall,
  IllusTangerineLarge,
  IllusTangerineMedium,
  IllusTangerineSmall,
} from '../assets';

import { theme } from '@garnish/constants';
import { ChallengeCardVariants } from '../../ChallengeCard/ChallengeCard.constants';
import type { ChallengeCardVariantsType } from '../../ChallengeCard/ChallengeCard.types';

// ─────────────────────────────────────────────────────────────────────────────

const images = {
  [ChallengeCardVariants.Completed]: [
    IllusBlueberryLarge,
    IllusGrapefruitLarge,
    IllusTangerineLarge,
  ],
  [ChallengeCardVariants.Ongoing]: [
    IllusBlueberryMedium,
    IllusGrapefruitMedium,
    IllusTangerineMedium,
  ],
  [ChallengeCardVariants.New]: [
    IllusBlueberrySmall,
    IllusGrapefruitSmall,
    IllusTangerineSmall,
  ],
} as const;

function getRandomIllustration(variant: ChallengeCardVariantsType) {
  const imageGroup = images[variant];

  return imageGroup[Math.floor(Math.random() * imageGroup.length)];
}

// ─────────────────────────────────────────────────────────────────────────────

export const LoyaltyChallengeImage = ({
  variant,
  testID,
}: LoyaltyChallengeImageProps) => {
  const image = useRef(getRandomIllustration(variant));

  return (
    <View style={styles.wrapper} testID={testID}>
      <Image
        style={styles.image}
        source={image.current}
        accessibilityIgnoresInvertColors
        resizeMode="stretch"
      />
    </View>
  );
};

// -------------------- STYLES --------------------

const styles = StyleSheet.create({
  wrapper: {
    marginBottom: theme.spacing.medium,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.KALE,
  },
  image: {
    width: '100%',
    height: 130,
  },
});

// -------------------- TYPES --------------------

export type LoyaltyChallengeImageProps = {
  readonly variant: ChallengeCardVariantsType;
} & Pick<ViewProps, 'testID'>;
